var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 236,
    viewBox: "0 0 236 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.234 121.947C224.234 180.869 176.48 228.634 117.554 228.634C58.6279 228.634 10.8711 180.873 10.8711 121.947C10.8711 63.0354 58.6242 22.0156 117.55 22.0156C176.477 22.0156 224.234 63.0317 224.234 121.947Z",
    fill: "#A7A8AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M197.393 122.794C197.393 166.9 161.646 202.65 117.536 202.65C73.4263 202.65 37.6797 166.9 37.6797 122.794C37.6797 78.6984 73.43 48 117.536 48C161.642 48 197.393 78.6984 197.393 122.794Z",
    fill: "#E7E6E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.421 129.541C127.421 136.017 122.277 141.253 115.928 141.253C109.578 141.253 104.434 136.017 104.434 129.541V74.5017C104.434 68.0448 109.578 62.8086 115.928 62.8086C122.281 62.8086 127.421 68.0448 127.421 74.5017V129.541Z",
    fill: "#25333A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.937 136.396C121.294 141.282 114.954 142.772 111.766 139.741C108.585 136.718 109.752 130.314 114.396 125.428L153.914 83.844C158.555 78.9605 164.902 77.4582 168.083 80.4811C171.272 83.5116 170.1 89.9266 165.456 94.8128L125.937 136.396Z",
    fill: "#25333A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock2);
export default __webpack_public_path__ + "static/media/clock2.a8adc18679a3fec993afbee254d6ec83.svg";
export { ForwardRef as ReactComponent };